import { EMPTY_FUNCTION, EMPTY_LIST } from '../../../constants/common'
import { SearchTypeButton } from '../SearchTypeButton'

import * as styles from './SearchTypes.module.css'

/**
 * @typedef {object} SearchTypeInputItemProps
 *
 * @property {boolean} selected
 * @property {SearchType} value
 * @property {(type: SearchType) => void} onSelect
 *
 */

/**
 * @param {React.ComponentType<SearchTypeInputItemProps>} [Item]
 * @param {string} [className]
 * @param {SearchType[]} [items]
 * @param {SearchType} value
 * @param {(value: SearchType) => void} [onChange]
 */
function SearchTypeInput({
  Item = SearchTypeButton,
  className = styles.SearchTypeInput,
  items = EMPTY_LIST,
  value,
  onChange = EMPTY_FUNCTION,
}) {
  return (
    <div className={className}>
      {items.map((item, index) => (
        <Item
          key={index}
          selected={item === value}
          value={item}
          onSelect={onChange}
        />
      ))}
    </div>
  )
}

export default SearchTypeInput
